// extracted by mini-css-extract-plugin
module.exports = {"dropdownAction":"_3lMi6hyy","link":"WmKe9b2l","isIconText":"_1jx8v9zu","actionAnnotation":"_2Vh_wBEG","actionText":"_2CM90mGV","isSelected":"_3grjcluT"};